import { Box, Typography, Container } from "@mui/material";
import EngineeringIcon from "@mui/icons-material/Engineering";
import PrecisionManufacturingIcon from "@mui/icons-material/PrecisionManufacturing";
import HandymanIcon from "@mui/icons-material/Handyman";

const brandBlue = "#1a237e";
const brandRed = "#d50000";

export default function OurExpertise() {
  const skills = [
    {
      icon: <EngineeringIcon sx={{ fontSize: 50, color: brandBlue }} />,
      title: "Acoustic & Power Engineering",
      description:
        "Custom-built and drop-over generator enclosures, room attenuation, soundproof systems, exhaust mufflers, and related acoustic solutions.",
    },
    {
      icon: <PrecisionManufacturingIcon sx={{ fontSize: 50, color: brandBlue }} />,
      title: "Industrial Metal Fabrication",
      description:
        "Structural metal works, lifting frames, platforms, ladders, reservoirs, hoppers, skid frames, custom fabrication, and engineered metal components.",
    },
    {
      icon: <HandymanIcon sx={{ fontSize: 50, color: brandBlue }} />,
      title: "Fuel Tanks & Piping Systems",
      description:
        "Single & double-wall fuel tanks (mild steel & stainless steel), fuel piping, transfer systems, instrumentation, and containerized fuel solutions.",
    },
  ];


  return (
    <Box sx={{ py: { xs: 8, md: 12 }, backgroundColor: "#f9f9ff" }}>
      <Container maxWidth="lg">
        {/* Heading */}
        <Typography
          variant="h4"
          fontWeight={800}
          sx={{
            mb: 4,
            color: brandBlue,
            fontSize: { xs: "1.8rem", md: "2.3rem" },
            textAlign: "center",
          }}
        >
          Our Expertise
        </Typography>

        {/* Red underline accent */}
        <Box
          sx={{
            width: 80,
            height: 4,
            background: brandRed,
            borderRadius: 2,
            mx: "auto",
            mb: 6,
          }}
        />

        {/* Cards */}
        <Box
          sx={{
            display: "flex",
            gap: 4,
            flexWrap: "wrap",
            justifyContent: "center",
          }}
        >
          {skills.map((s, i) => (
            <Box
              key={i}
              sx={{
                flex: "1 1 280px",
                p: 4,
                textAlign: "center",
                borderRadius: 3,
                backgroundColor: "#fff",
                boxShadow: "0 6px 18px rgba(0,0,0,0.1)",
                transition: "all 0.3s ease",
                "&:hover": {
                  transform: "translateY(-6px)",
                  boxShadow: `0 12px 30px ${brandBlue}33`, // subtle brand color shadow
                  border: `1px solid ${brandRed}`,
                },
              }}
            >
              <Box sx={{ mb: 2 }}>{s.icon}</Box>
              <Typography
                variant="h6"
                fontWeight={700}
                sx={{ mb: 1, color: brandBlue }}
              >
                {s.title}
              </Typography>
              <Typography sx={{ color: "text.secondary", lineHeight: 1.6 }}>
                {s.description}
              </Typography>
            </Box>
          ))}
        </Box>
      </Container>
    </Box>
  );
}
